import { Component, OnInit, Input, NgZone, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonfunctionService } from '../../../services/commonfunction.service';
import { LegacyPropertyList, ExistingPropertyList, FloorList, UnitList, FloorListExisting, UnitListExisting } from '../legacy-component/legacy-component.component';
import { ConfirmationDialog } from '../confirmation-box/onfirmation-dialog';
import { PropertyMap } from '../legacy-component/components/property-map/property-map';
import { ShareService } from '../../services/share.service';
import { ApiserviceService } from '../../../../../src/app/apiservice.service';
import { NotificationService } from '../../services/notification.service';
import { Subscription } from 'rxjs';


  /**
 *
 * <strong>List of API using</strong>
 * <ol>
 * <li>estapi_upload_type_uploads_status_get</li>
 * <li>estapi_properties_property_id_floors_get</li>
 * <li>estapi_properties_property_id_floors_floor_id_units_get</li>
 * <li>estapi_upload_type_uploads_upload_id_resolution_get</li>
 * </ol>
 *
 */

@Component({
  selector: 'app-newcsv-legacy-component',
  templateUrl: './newcsv-legacy-component.component.html',
  styleUrls: ['./newcsv-legacy-component.component.css']
})

export class NewcsvLegacyComponentComponent implements OnInit, OnDestroy {
  loader_1: boolean = false;
  loader_2: boolean = false;
  entity_type: any;
  entity_type_existing: any;

  legacy_property_list: Array<LegacyPropertyList> = [];
  existing_property_list: Array<ExistingPropertyList> = [];

  legacyDataList: any = [];
  existingDataList: any = [];
  filteredPropertyList: any = [];
  floor_list_existing: any = [];

  selected_property: any;
  selected_floor: FloorList;
  selected_unit: UnitList;

  selected_property_existing: ExistingPropertyList;
  selected_floor_existing: FloorList;
  selected_unit_existing: UnitList;

  selected_assignment:any;
  private subs = new Subscription();
  // @Output() backbutton: EventEmitter<any> = new EventEmitter();
  @Input() conflictData;
  data: any;
  resolveLoader: boolean=false;
  constructor(private readonly dialog: MatDialog,
    private readonly fnc: CommonfunctionService,
    private readonly zone: NgZone, private readonly share: ShareService,
    private readonly api: ApiserviceService,
    private readonly notify: NotificationService) {
    this.data = this.share.csv_obj;
    this.selected_assignment = this.fnc.getArrayValue('assignment_id', this.data.selected_assignment, this.data.assignmentList);

  }

  select(data) {
    if (data) {
      if (data.entity_type == 'property') {
        this.selected_property_existing = null;
        let arr = [];
        if (data) {
          this.selected_property = data;
        }
        if (this.selected_property) {
          this.existing_property_list.forEach((prop) => {
            if (prop.legacy_property_uid == this.selected_property.legacy_property_uid) {
              arr.push(prop);
            }
          })
          this.existingDataList = arr;
          this.filteredPropertyList = arr;
          this.entity_type_existing = null;
          this.selected_floor_existing = null;
          this.selected_unit_existing = null;
        }
      }
      if (data.entity_type == 'property_floor') {
        this.selected_floor = data;
      }
      if (data.entity_type == 'property_unit') {
        this.selected_unit = data;
      }
      if (data.entity_type == 'property_existing') {
        this.selected_property_existing = data;
      }
      if (data.entity_type == 'property_floor_existing') {
        this.selected_floor_existing = data;
      }
      if (data.entity_type == 'property_unit_existing') {
        this.selected_unit_existing = data;
      }
    }
  }

  isSelected(type, data) {
    if (type == 'existing' && data.entity_type == 'property_unit_existing') {
      if (this.selected_unit_existing) {
        if (this.selected_unit_existing.unit_number == data.unit_number) {
          return true;
        } else {
          return false;
        }
      }
    }
    if (type == 'existing' && data.entity_type == 'property_floor_existing') {
      if (this.selected_floor_existing) {
        if (this.selected_floor_existing.floor_number == data.floor_number) {
          return true;
        } else {
          return false;
        }
      }
    }
    if (type == 'legacy' && data.entity_type == 'property_floor') {
      if (this.selected_floor) {
        if (this.selected_floor.floor_number == data.floor_number) {
          return true;
        } else {
          return false;
        }
      }
    }
    if (type == 'legacy' && data.entity_type == 'property_unit') {
      if (this.selected_unit) {
        if (this.selected_unit.unit_number == data.unit_number) {
          return true;
        } else {
          return false;
        }
      }
    }
    if (type == 'legacy' && data.entity_type == 'property') {
      if (this.selected_property) {
        if (data.legacy_property_uid == this.selected_property.legacy_property_uid) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
    if (this.selected_property_existing && data.entity_type == 'property_existing') {
      if (data.property_id == this.selected_property_existing.property_id) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  select_existing(data) {
    if (data) {
      this.selected_property_existing = data.property_uid;
    }
  }

  getProperty(type) {
    if (type == 'legacy') {
      this.legacyDataList = this.legacy_property_list;
      this.selected_floor = null;
      this.selected_unit = null;
      this.entity_type = 'property';
    } else {
      if(this.selected_property){
        this.select(this.selected_property);
      }else{
        this.existingDataList = [];
      }
      this.selected_floor_existing = null;
      this.entity_type_existing = null;
    }

  }

  //Get legacy and existing properties--------------------------------------
  getLegacyData() {
   if (this.conflictData) {
    this.loader_1 = true
    let upload_id = this.conflictData.upload_id;
    let upload_count = this.conflictData.upload_count;
    let status = this.conflictData.status;
    let url = `get-conflict-data?upload_id=${upload_id}&upload_count=${upload_count}&status=${status}`;
    const legacySub = this.api.getNodeData(url).subscribe({next: (res: any) => {
      this.loader_1 = false;
      if(res.status == 200){
        let conflict_data = res.data;
        let legacy_arr = conflict_data.legacy_properties, temp_arr = [];
        let existing_arr = conflict_data.existing_properties, temp_ex_arr = [];
        existing_arr.forEach(ex_prop => {
          let ex_obj: ExistingPropertyList = {
            property_uid: ex_prop.property_uid,
            property_id: ex_prop.property_id,
            property_name: ex_prop.property_name,
            legacy_property_uid: ex_prop.legacy_property_uid,
            lat: ex_prop.lat,
            lon: ex_prop.lon,
            no_of_unit: ex_prop.no_of_unit,
            no_of_floor: ex_prop.no_of_floor,
            entity_type: 'property_existing'
          }
          temp_ex_arr.push(ex_obj);
        });
        this.existing_property_list = temp_ex_arr;
        legacy_arr.forEach(prop => {
          let temp_floor = [], temp_unit = [], floor_count = 0, unit_count = 0;

          prop.unit.forEach(un => {
            unit_count++;
            let un_obj: UnitList = {
              unit_area: un.unit_area,
              unit_number: un.unit_number,
              legacy_property_uid: un.legacy_property_uid,
              floor_number: un.floor_number,
              unit_type: un.unit_type,
              unit_property_type: un.unit_property_type,
              entity_type: 'property_unit'
            }
            temp_unit.push(un_obj);
          });
          prop.floor.forEach(fl => {
            let floor_unit_count = 0;
            floor_count++;
            temp_unit.forEach((u) => {
              if (u.floor_number == fl.floor_number) {
                floor_unit_count++;
              }
            })
            let fl_obj: FloorList = {
              legacy_property_uid: fl.legacy_property_uid,
              floor_number: fl.floor_number,
              floor_type: fl.floor_type,
              no_of_unit: floor_unit_count,
              entity_type: 'property_floor'
            }
            temp_floor.push(fl_obj);
          });

          let obj: LegacyPropertyList = {
            legacy_property_uid: prop.legacy_property_uid,
            lat: prop.lat,
            lon: prop.lon,
            property_name: prop.property_name,
            no_of_unit: unit_count,
            no_of_floor: floor_count,
            floor: temp_floor,
            unit: temp_unit,
            entity_type: 'property'
          }
          temp_arr.push(obj);
        });
        this.legacy_property_list = temp_arr;
        this.legacyDataList = this.legacy_property_list;
      }else{
        this.notify.notify(res.massage, 'warn')
      }

    }, error:() => {
      this.loader_1 = false;
    }})
    this.subs.add(legacySub);

    }

  }

  //Get legacy floors--------------------------------------
  getFloors(type, data?) {
    if (type == 'existing') {
      if (data) {
        this.selected_property_existing = data;
        this.selected_unit_existing = null;
        this.getExistingFloors(data);
      } else {
        this.selected_unit_existing = null;
        this.existingDataList = this.floor_list_existing;
        this.entity_type_existing = 'property_floor_existing'
      }

    } else {
      if (data) this.selected_property = data;
      this.selected_unit = null;
      this.legacyDataList = this.selected_property.floor;
      this.entity_type = 'property_floor';
    }
  }


  //Get legacy and existing units--------------------------------------
  getUnits(data?) {
    if (data.entity_type == 'property_floor_existing') {
      if (data.no_of_unit != 0) {
        this.getExistingUnits(data);
      } else {
        this.notify.notify('No Units found', 'warn');
      }
      return;
    }
    if (data.entity_type == 'property_floor') {
      let arr = [];
      let units = this.selected_property.unit;
      this.selected_floor = data;
      units.forEach(u => {
        if (this.selected_floor.floor_number == u.floor_number) {
          arr.push(u);
        }
      });
      this.legacyDataList = arr;
      this.entity_type = 'property_unit';
      return;
    }
  }

  //Get existing floors-------------------------------
  getExistingFloors(data) {

    let fl_arr = [];
    this.loader_2 = true;
    let url = `properties/${data.property_id}/floors`;
    const existingSub = this.api.getEpsData(url).subscribe({next:(res:any) => {
      console.log(res);
      this.loader_2 = false;
      res.forEach(floor => {
        let obj: FloorListExisting = {
          floor_uid: floor.floor_uid,
          floor_id: floor.floor_id,
          floor_number: floor.sort_order,
          floor_type: floor.floor_type_name,
          no_of_unit: floor.no_of_units,
          entity_type: 'property_floor_existing'
        }
        fl_arr.push(obj);
      });
      this.floor_list_existing = fl_arr;
      this.existingDataList = this.floor_list_existing;
      this.entity_type_existing = 'property_floor_existing';
    }, error:()=> {
      this.loader_2 = false;
      this.existingDataList = [];
    }})
    this.subs.add(existingSub);
  }

  //Get existing units-------------------------------
  getExistingUnits(data) {
    this.selected_floor_existing = data;
    let un_arr = [];
    this.loader_2 = true;
    let url = `properties/${this.selected_property_existing.property_id}/floors/${data.floor_id}/units?return_measure_units=true`;
    const unitSub = this.api.getEpsData(url).subscribe({next: (res:any) => {
      this.loader_2 = false;
      res.forEach(unit => {
        let obj: UnitListExisting = {
          unit_area: unit.data.unit_area,
          unit_number: unit.data.unit_number,
          unit_uid: unit.unit_uid,
          floor_number: unit.floor_id,
          unit_type: unit.unit_type_name,
          unit_property_type: unit.property_type_name,
          entity_type: 'property_unit_existing'
        }
        un_arr.push(obj);
      });
      this.existingDataList = un_arr;
      this.entity_type_existing = 'property_unit_existing';
      this.loader_2 = false;
    }, error:() => {
      this.loader_2 = false;
    }})
    this.subs.add(unitSub);
  }

  createProperty(e) {
    let body, url = `upload-legacy/resolution`;
    body = {
      "action": 1,
      "legacy_property_uid": e.legacy_property_uid,
      "property_uid": e.property_uid,
      "updated_by": this.api.user_id,
      "upload_count": this.conflictData.upload_count,
      "conflict_id": this.conflictData.upload_id,
    }
    this.resolveLoader= true;
    const createSub = this.api.patchNodeData(url, body).subscribe({next: (res:any) => {
      this.resolveLoader= false;
      if(res.status == 200){
        this.notify.notify(res.message, 'success');
        this.legacyDataList = this.fnc.getDeletedArray('legacy_property_uid', e.legacy_property_uid, this.legacyDataList);
        this.existingDataList = [];
        this.selected_property = null;
        this.selected_property_existing = null;
        this.entity_type_existing = '';
        this.entity_type = '';
        this.getLegacyData();
      }else{
        this.notify.notify(res.message, 'warn');
      }

    }, error:(err) => {
      this.resolveLoader= false;
      this.notify.notify(err, 'error');
    }})
    this.subs.add(createSub);
  }

  removeProperty(e) {
    let body, url = `upload-legacy/resolution`;
    body = {
      "action": 3,
      "legacy_property_uid": e.legacy_property_uid,
      "property_uid": e.property_uid,
      "updated_by": this.api.user_id,
      "upload_count": this.conflictData.upload_count,
      "conflict_id": this.conflictData.upload_id,
    }
    this.resolveLoader= true;
    const removeSub = this.api.patchNodeData(url, body).subscribe({next: (res:any) => {
      this.resolveLoader= false;
      if(res.status == 200){
      this.notify.notify('Property successfully removed', 'success');
      this.legacyDataList = this.fnc.getDeletedArray('legacy_property_uid', e.legacy_property_uid, this.legacyDataList);
      this.existingDataList = [];
      this.selected_property_existing = null;
      this.selected_property = null;
      this.entity_type_existing = '';
      this.entity_type = '';
      this.getLegacyData();
      }else{
        this.notify.notify('Remove Property failed', 'warn');
      }
    }, error: (err) => {
      this.resolveLoader= false;
      this.notify.notify(err, 'error');
    }})
    this.subs.add(removeSub);
  }

  mergeProperty(e) {
    if(this.data.useNewApi){
      let body, url = `upload-legacy/resolution`;
      body = {
        "action": 2,
        "legacy_property_uid": e.legacy_property_uid,
        "property_uid": e.property_uid,
        "updated_by": this.api.user_id,
        "upload_count": this.conflictData.upload_count,
        "conflict_id": this.conflictData.upload_id,
      }
      this.resolveLoader= true;
      const mergeSub = this.api.patchNodeData(url, body).subscribe({next:(res:any) => {
        this.resolveLoader= false;
        if(res.status == 200){
        this.notify.notify('Property successfully merged', 'success');
        this.legacyDataList = this.fnc.getDeletedArray('legacy_property_uid', this.selected_property.legacy_property_uid, this.legacyDataList);
        this.existingDataList = this.fnc.getDeletedArray('legacy_property_uid', e.legacy_property_uid, this.existingDataList);
        this.existingDataList = [];
        this.selected_property_existing = null;
        this.selected_property = null;
        this.entity_type_existing = '';
        this.entity_type = '';
        this.getLegacyData();
        }else{
          this.notify.notify('Property merge Failed', 'success');
        }
      }, error:(err) => {
        this.resolveLoader= false;
        this.notify.notify(err, 'error');
      }})
      this.subs.add(mergeSub);
    }
  }


  confirm(t,e) {
    let dialogRef = this.dialog.open(ConfirmationDialog, {
      width: '350px',
      panelClass: 'create-master-panel',
      data: { parent: this, elem: e, type: t }//optional
    });
    const confirmSub = dialogRef.afterClosed().subscribe(result => {

    });
    this.subs.add(confirmSub);
  }
  openMap() {
    let dialogRef = this.dialog.open(PropertyMap, {
      width: '550px',
      panelClass: 'create-master-panel',
      data: { parent: this }//optional
    });
    const openMapSub = dialogRef.afterClosed().subscribe(result => {

    });
    this.subs.add(openMapSub);
  }

  ngOnInit() {
    this.getLegacyData();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
